import type { TranslationTree } from '../../types';

export const toolPickers: TranslationTree = {
  toolPickers: {
    reference: {
      placeholder: 'Rechercher ou saisir une référence',
      listTitle: 'Références existantes · {{count}}',
      empty: 'Aucune référence',
      toolCount: { one: '{{count}} outil', other: '{{count}} outils' },
      current: 'actuelle',
      create: 'Créer la nouvelle référence « {{reference}} »',
      hint: 'Choisissez une référence existante. Une valeur absente de la liste crée une nouvelle référence.',
      currentHint: "Référence actuelle de l'outil.",
      existing: 'Référence existante · {{tools}}',
      existingAlias: 'Référence existante · {{tools}} · alias « {{alias}} »',
      nearTitle: 'Référence proche :',
      near: '{{reference}} existe déjà ({{tools}}). Telle quelle, « {{value}} » créera une nouvelle référence.',
      use: 'Utiliser {{reference}}',
      newTitle: 'Nouvelle référence.',
      new: "« {{value}} » n'existe pas encore : elle sera créée avec cet outil.",
    },
    toolId: {
      listTitle: "Outils de l'entreprise · {{count}}",
      empty: 'Aucun outil ne correspond',
      more: 'et {{count}} autres : précisez la recherche',
      noReference: 'sans référence',
      traces: { none: 'aucun relevé', one: '{{count}} relevé', other: '{{count}} relevés' },
      lastTrace: 'dernier le {{date}}',
      known: 'Référence {{reference}} · {{traces}}',
      knownNoReference: 'Sans référence · {{traces}}',
      near: 'Aucun outil « {{value}} ». Vouliez-vous dire {{toolId}} ?',
      use: 'Utiliser',
      unknown: 'Aucun outil « {{value}} » dans votre entreprise.',
      create: 'Créer cet outil',
    },
    existingIds: {
      hint: "Les identifiants déjà enregistrés s'affichent pendant la saisie.",
      takenTitle: 'Cet outil existe déjà',
      taken:
        "(référence {{reference}}, {{traces}}). Un identifiant ne peut être enregistré qu'une fois.",
      openTool: 'Ouvrir la fiche de {{toolId}} et modifier sa référence →',
      near: "{{toolId}} existe déjà : seule la casse ou les séparateurs diffèrent. Vérifiez le marquage de l'outil.",
      listTitle: 'Identifiants déjà enregistrés · {{count}}',
      more: 'et {{count}} autres',
      nextFree: 'Numéro suivant libre :',
      use: 'Utiliser',
      takenShort: '{{toolId}} existe déjà : modifiez sa référence sur sa fiche.',
      takenElsewhere: 'Cet identifiant est déjà enregistré par une autre entreprise.',
    },
    edit: {
      button: 'Modifier',
      buttonLabel: 'Modifier la référence',
      label: 'Nouvelle référence de {{toolId}}',
      note: "Les relevés de l'outil ne changent pas. Seul son classement change.",
      move: "Les relevés de l'outil ne changent pas. Dans la liste des outils, il quitte {{from}} ({{left}} y restent) pour {{to}}.",
      moveLast:
        "Les relevés de l'outil ne changent pas. Dans la liste des outils, il quitte {{from}}, qui n'aura plus aucun outil, pour {{to}}.",
      newReference: '{{reference}} (nouvelle)',
      save: 'Enregistrer',
      cancel: 'Annuler',
      saved: 'Référence modifiée : {{from}} → {{to}}.',
      savedNew: 'Référence modifiée : {{from}} → {{to}} (nouvelle référence créée).',
      error: "La référence n'a pas pu être modifiée.",
    },
  },
};
